import { Badge, Button } from 'src/components/atoms';
import styled from 'styled-components';

export const MessageCountBadge = styled(Badge)`
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(30%, -30%);
  font-size: 8px;
  width: 18px;
  height: 18px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: default;
`;

export const ButtonWithMessageCountContainer = styled(Button)`
  position: relative;
`;
